import { render, staticRenderFns } from "./ReportTemplateConfig.vue?vue&type=template&id=2910e2f5&"
import script from "./ReportTemplateConfig.vue?vue&type=script&lang=js&"
export * from "./ReportTemplateConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports